/* Skeleton for one store row. Mirrors the real row's geometry — pin, two text
   lines, a status and a button — so the list does not jump when it loads. */
export default function LocationLoader () {
    return (
        <div className="wo-loc__row wo-loc__row--skel" aria-hidden="true">
            <span className="wo-skel wo-skel--pin"></span>
            <span className="wo-loc__body">
                <span className="wo-skel wo-skel--name"></span>
                <span className="wo-skel wo-skel--line"></span>
                <span className="wo-skel wo-skel--line wo-skel--short"></span>
            </span>
            <span className="wo-loc__right">
                <span className="wo-skel wo-skel--pill"></span>
                <span className="wo-skel wo-skel--btn"></span>
            </span>
        </div>
    )
}
